import { useEffect, useState } from 'react';
import { isSessionUsable, logout, fetchAndCacheMe } from '../utils/auth';
import { bootstrapPlaybackSync } from '../utils/playbackSyncBootstrap';
import { bootstrapOffline } from '../utils/offline/bootstrap';

/**
 * ProtectedRoute component that checks token validity before rendering children
 * Redirects to login if token is expired or invalid.
 *
 * Offline, an expired token does NOT redirect (FR-025) — see `isSessionUsable`.
 */
function ProtectedRoute({ children }) {
  const [isChecking, setIsChecking] = useState(true);
  const [isValid, setIsValid] = useState(false);

  useEffect(() => {
    const checkAuth = async () => {
      const valid = isSessionUsable();

      if (!valid) {
        logout();
      } else {
        await fetchAndCacheMe();
        bootstrapPlaybackSync();
        bootstrapOffline();
        setIsValid(true);
      }

      setIsChecking(false);
    };

    checkAuth();
  }, []);

  // Show loading state while checking authentication
  if (isChecking) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-background-light dark:bg-background-dark">
        <div className="text-center">
          <div className="inline-block h-8 w-8 animate-spin rounded-full border-4 border-solid border-primary border-r-transparent" />
          <p className="mt-4 text-gray-600 dark:text-gray-400">Checking authentication...</p>
        </div>
      </div>
    );
  }

  // If token is valid, render the protected content
  return isValid ? children : null;
}

export default ProtectedRoute;

